<template>
	<PopupRouterView :showLeftIcon="true" label="Purchase Order Input" okTitle="Save" cancelTitle="Cancel"
		entityName="purchaseorder" :documentId="mainRecordId" @saveMethod="saveAction" @hideMethod="onHidden"
		ref="purchaseOrderInput">


		<b-card header="Purchase Order" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Order Number"
						:model="model.purchaseOrderNumber" />
					<app-input-combobox-autocomplete :options="purchaseRequests" optionsLabel="purchaseRequestNumber"
						optionsKey="id" label-cols-lg="12" label="Purchase Request Number" id="fieldset-purchase-request"
						size="sm" :model.sync="model.purchaseRequestId"
						:selected="model.purchaseRequest != null ? model.purchaseRequest.purchaseRequestNumber : ''"
						@input="getPurchaseRequests" @change="updateData" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedPurchaseRequest" />
					<app-input-datepicker id="fieldset-purchase-order-date" label-cols-lg="12" label="Purchase Order Date"
						size="sm" :model.sync="model.purchaseOrderDate"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" />
					<app-input-datepicker id="fieldset-delivery-date-request" label-cols-lg="12"
						label="Delivery Date Request" size="sm" :model.sync="model.deliveryDateRequest"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" />
					<app-input-textarea id="fieldset-purpose" label-cols-lg="12" label="Purpose" label-for="input-purpose"
						size="sm" :model.sync="model.purpose" @change="updateData" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"
						:selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData"
						:isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
					<app-label label-cols-lg="12" size="sm" label="Contact Person"
						:model="(model.vendor != null) ? model.vendor.contactPerson : null" />
					<app-input-textbox id="fieldset-quotation-number" label-cols-lg="12" label="Quotation Number"
						label-for="input-quotation-number" size="sm" :model.sync="model.quotationNumber"
						@change="updateData" />
					<app-input-datepicker id="fieldset-quotation-date" label-cols-lg="12" label="Quotation Date" size="sm"
						:model.sync="model.quotationDate"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" />
				</b-col>

			</b-row>
		</b-card>

		<b-card header="Purchase Order Detail" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="12">
					<app-table-input title="Purchase Order Detail" :bordered="true" :items="purchaseOrderDetails"
						:fields="fieldsPurchaseOrderDetail" :busy="isDataLoading" :sort-by.sync="sortByPurchaseOrderDetail"
						:sort-desc.sync="sortDescPurchaseOrderDetail" small responsive
						@editButtonMethod="editRowDataPurchaseOrderDetail"
						@deleteButtonMethod="deleteRowDataPurchaseOrderDetail"
						@showPopupAddMethod="addDataPurchaseOrderDetail()"
						@showPopupUploadMethod="showPopupUploadPurchaseOrderDetail()"
						@downloadMethod="downloadPurchaseOrderDetail()"
						@addFromClipboardMethod="addFromClipboardPurchaseOrderDetail()"
						@replaceFromClipboardMethod="replaceFromClipboardPurchaseOrderDetail()" :showActionButton="true"
						:showDeleteButton="true" :showAddButton="true" :showAddFromClipboardButton="false"
						:showReplaceFromClipboardButton="false" :showUploadButton="true" :showDownloadButton="true"
						:isDownloadBusy="isDownloadPurchaseOrderDetail">

						<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseOrderDetailFilter = !isShowPurchaseOrderDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->

						<template #top-row v-if="isShowPurchaseOrderDetailFilter">
							<b-th></b-th>
							<b-th stacked-heading="Part Code">
								<v-select id="input-purchase-order-detail-part-table" append-to-body label="partNumber"
									:options="parts" :value="filterPurchaseOrderDetail.partId" :reduce="item => item.id"
									v-model="filterPurchaseOrderDetail.partId" @search="getParts"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty PO">
								<b-form-input id="input-purchase-order-detail-qty-po-table"
									v-model="filterPurchaseOrderDetail.qtyPo" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Price (Rp/Unit)">
								<b-form-input id="input-purchase-order-detail-price-unit-table"
									v-model="filterPurchaseOrderDetail.priceUnit" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Subtotal (Rp)">
								<b-form-input id="input-purchase-order-detail-subtotal-table"
									v-model="filterPurchaseOrderDetail.subtotal" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Ppn">
								<b-form-input id="input-purchase-order-detail-price-ppn-table"
									v-model="filterPurchaseOrderDetail.pricePpn" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Amount">
								<b-form-input id="input-purchase-order-detail-amount-table"
									v-model="filterPurchaseOrderDetail.amount" size="sm"></b-form-input>
							</b-th>

							<b-th></b-th>
						</template>

						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + (purchaseOrderDetailPageSize * (currentPurchaseOrderDetailPage - 1))) }}
						</template>

						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(part)="row">
							<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
								:id="'input-purchase-order-detail-part-' + row.index" label-cols-lg="12" label="Part Code"
								size="sm" :model.sync="row.item.partId" :state="validateState('partId')"
								:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
								@change="saveInputPurchaseOrderDetail(row.item)"
								:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
								:loading="isPartComboLoading" :nolabel="true" />
						</template>
						<template v-slot:cell(partName)="row">
							<app-label label-cols-lg="12" size="sm" label="Part Name"
								:model="(row.item.part != null) ? row.item.part.partName : null" />
						</template>
						<template v-slot:cell(qtyPo)="row">
							<app-input-textbox :id="'input-purchase-order-detail-qty-po-' + row.index" label-cols-lg="12"
								label="Qty PO" size="sm" :model.sync="row.item.qtyPo" :state="validateState('qtyPo')"
								:errorMessage="getErrorMessage(errorMessage.qtyPo, 'qtyPo')"
								@change="saveInputPurchaseOrderDetail(row.item)" :nolabel="true" />
						</template>
						<template v-slot:cell(uom)="row">
							<app-label label-cols-lg="12" size="sm" label="Uom"
								:model="(row.item.part != null) ? (row.item.part.uom != null) ? row.item.part.uom.code : null : null" />
						</template>
						<template v-slot:cell(priceUnit)="row">
							<app-input-textbox :id="'input-purchase-order-detail-price-unit-' + row.index"
								label-cols-lg="12" label="Price (Rp/Unit)" size="sm" :thousandSeparator="true"
								:model.sync="row.item.priceUnit" :state="validateState('priceUnit')"
								:errorMessage="getErrorMessage(errorMessage.priceUnit, 'priceUnit')"
								@change="saveInputPurchaseOrderDetail(row.item)" :nolabel="true" />
						</template>
						<template v-slot:cell(subtotal)="row">
							<app-input-textbox :id="'input-purchase-order-detail-subtotal-' + row.index" label-cols-lg="12"
								label="Subtotal (Rp)" size="sm" :thousandSeparator="true" :model.sync="row.item.subtotal"
								:state="validateState('subtotal')"
								:errorMessage="getErrorMessage(errorMessage.subtotal, 'subtotal')"
								@change="saveInputPurchaseOrderDetail(row.item)" :nolabel="true" />
						</template>
						<template v-slot:cell(pricePpn)="row">
							<app-input-textbox :id="'input-purchase-order-detail-price-ppn-' + row.index" label-cols-lg="12"
								label="Ppn" size="sm" :thousandSeparator="true" :model.sync="row.item.pricePpn"
								:state="validateState('pricePpn')"
								:errorMessage="getErrorMessage(errorMessage.pricePpn, 'pricePpn')"
								@change="saveInputPurchaseOrderDetail(row.item)" :nolabel="true" />
						</template>
						<template v-slot:cell(amount)="row">
							<app-input-textbox :id="'input-purchase-order-detail-amount-' + row.index" label-cols-lg="12"
								label="Amount" size="sm" :thousandSeparator="true" :model.sync="row.item.amount"
								:state="validateState('amount')"
								:errorMessage="getErrorMessage(errorMessage.amount, 'amount')"
								@change="saveInputPurchaseOrderDetail(row.item)" :nolabel="true" />
						</template>


						<template v-slot:form-add-detail>
							<PurchaseOrderDetailInput :model="modelPurchaseOrderDetail"
								:openPopup="isShowPopupPurchaseOrderDetail" @resetMethod="resetModal"
								@addButtonMethod="addRowDataPurchaseOrderDetail" />
						</template>
						<template v-slot:upload-detail>
							<PurchaseOrderDetailUpload :openPopup="isShowPopupUploadPurchaseOrderDetail"
								@resetMethod="resetModal" @uploadButtonMethod="uploadDataPurchaseOrderDetail"
								:parentId="modelId" />
						</template>
						<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseOrderDetailPage"
				:total-rows="totalPurchaseOrderDetailRow"
				:per-page="purchaseOrderDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
					</app-table-input>
				</b-col>

			</b-row>
		</b-card>



		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderList from '@/models/PurchaseOrder/PurchaseOrderList';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PurchaseOrderDetailInput from '@/views/PurchaseOrder/PurchaseOrderDetailInput';
import PurchaseOrderDetailUpload from '@/views/PurchaseOrder/PurchaseOrderDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components: {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		PurchaseOrderDetailInput, PurchaseOrderDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins: [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage: {
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPurchaseOrderDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Code", key: 'part', sortable: false } },
				{ "partName": { "class": "th-part-name", "label": "Part Name", key: 'partName', sortable: false } },
				{ "qtyPo": { "class": "th-qty-po last-child", "label": "Qty PO", key: 'qtyPo', sortable: false } },
				{ "uom": { "class": "th-uom d-stack-none", "label": "Uom", key: 'uom', sortable: false } },
				{ "priceUnit": { "class": "th-price-unit d-stack-none", "label": "Price (Rp/Unit)", key: 'priceUnit', sortable: false } },
				{ "subtotal": { "class": "th-subtotal d-stack-none", "label": "Subtotal (Rp)", key: 'subtotal', sortable: false } },
				{ "pricePpn": { "class": "th-price-ppn d-stack-none", "label": "Ppn", key: 'pricePpn', sortable: false } },
				{ "amount": { "class": "th-amount d-stack-none", "label": "Amount", key: 'amount', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPurchaseOrderDetail: {},
			isShowPopupPurchaseOrderDetail: false,
			isShowPopupUploadPurchaseOrderDetail: false,
			filterPurchaseOrder: null,
			currentPurchaseOrderPage: 1,
			purchaseOrderPageSize: 10,
			sortByPurchaseOrder: '',
			sortDescPurchaseOrder: '',
			filterPurchaseOrderDetail: null,
			currentPurchaseOrderDetailPage: 1,
			purchaseOrderDetailPageSize: 10,
			sortByPurchaseOrderDetail: '',
			sortDescPurchaseOrderDetail: '',
			sortingByPurchaseOrderDetail: [],
			purchaseOrderDetails: [],
			purchaseOrderDetailId: '',
			totalPurchaseOrderDetailRow: 0,
			isShowPurchaseOrderDetailFilter: false,
			isDownloadPurchaseOrderDetail: false,
			parts: [],
			purchaseRequests: [],
			purchaseRequests: [],
			isPurchaseRequestComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPurchaseRequestComboLoading: false,
			isVendorComboLoading: false,
			isPartComboLoading: false,
			isPurchaseOrderComboLoading: false,
		}
	},
	methods: {
		getPurchaseOrder: async function (id) {
			this.isBusy = true;
			PurchaseOrder.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if (this.model.vendorId != null) {
					promises.push(
						this.getVendor(this.model.vendorId).then(result => {
							return true;
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPurchaseOrder = true;
			this.filterPurchaseOrder.id = this.modelId;
			PurchaseOrder.downloadDataDetail(this, this.filterPurchaseOrder).then(result => {
				this.isDownloadPurchaseOrder = false;
			}).catch(error => { this.isDownloadPurchaseOrder = false; })
		},
		getPurchaseOrderDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseOrderDetail);
			if (this.modelId == null) return;
			filter.purchaseOrderId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPurchaseOrderDetail != null) {
				this.sortingByPurchaseOrderDetail[this.sortByPurchaseOrderDetail] = this.sortDescPurchaseOrderDetail;
			}
			let currentPage = (this.currentPurchaseOrderDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseOrderDetailRow + 1;
				let page = Math.ceil(totalData / this.purchaseOrderDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseOrderDetailPageSize = 0;
			// disable paging end
			PurchaseOrderDetail.getList(this, filter, this.sortingByPurchaseOrderDetail, currentPage, this.purchaseOrderDetailPageSize).then(result => {
				this.currentPurchaseOrderDetailPage = currentPage + 1;
				this.purchaseOrderDetails = result.data;
				this.totalPurchaseOrderDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.PurchaseOrderNumber = input;
			}
			this.isPurchaseOrderComboLoading = true;
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
					this.isPurchaseOrderComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			this.isPurchaseOrderComboLoading = true;
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
					this.isPurchaseOrderComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseRequests: async function (input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			PurchaseRequest.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseRequests = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPurchaseRequest(item) {
			if (item == undefined || item == null) {
				this.model.purchaseRequestId = null;
				this.model.purchaseRequest = null;
			} else {
				this.model.purchaseRequestId = item.id;
				this.model.purchaseRequest = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors: async function (input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendors = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedVendor(item) {
			if (item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendor: async function (id) {
			Vendor.getData(this, id).then(result => {
				this.model.vendor = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.purchaseOrderInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PurchaseOrder.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaseorderindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PurchaseOrder.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaseorderindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrder.updateData(this, model, id)
						.catch((error) => {
							this.getPurchaseOrder(id);
						});
				}
			});
		},
		onHidden() {
			this.getPurchaseOrders();
		},
		addRowDataPurchaseOrderDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				} else {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.createDataDetail(this, model)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				}
			}
		},
		async editRowDataPurchaseOrderDetail(id) {
			this.purchaseOrderDetailId = id;
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async deleteRowDataPurchaseOrderDetail(id) {
			PurchaseOrderDetail.deleteData(this, id).then(result => { this.getPurchaseOrderDetails(); });
		},
		async resetDataPurchaseOrderDetail() {
			this.purchaseOrderDetailId = "";
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async addDataPurchaseOrderDetail() {
			PurchaseOrderDetail.createData(this, { purchaseOrderId: this.modelId })
				.then(result => {
					this.getPurchaseOrderDetails(true);
				})
		},
		async addFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.addFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		async replaceFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.replaceFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		showPopupUploadPurchaseOrderDetail() {
			if (this.purchaseOrderDetails != null && this.purchaseOrderDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseOrderDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadPurchaseOrderDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadPurchaseOrderDetail = true;
			}
		},
		uploadDataPurchaseOrderDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseOrderDetail = false;
		},
		downloadPurchaseOrderDetail(modalEvent) {
			this.isDownloadPurchaseOrderDetail = true;
			this.filterPurchaseOrderDetail.purchaseOrderId = this.modelId;
			PurchaseOrderDetail.downloadDataDetail(this, this.filterPurchaseOrderDetail).then(result => {
				this.isDownloadPurchaseOrderDetail = false;
			}).catch(error => { this.isDownloadPurchaseOrderDetail = false; })
		},
		saveInputPurchaseOrderDetail(item) {
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.purchaseOrders != null && this.purchaseOrders != undefined && this.purchaseOrders.length > 0) {
				item.purchaseOrder = this.purchaseOrders.find(q => q.id == item.purchaseOrderId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrderDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPurchaseOrderDetail = false;
			this.isShowPopupPurchaseOrderDetail = false;
			if (modalType == 'PurchaseOrderDetail') {
				this.getPurchaseOrderDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowPurchaseOrderDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPurchaseOrder = new PurchaseOrderFilter();
		this.filterPurchaseOrderDetail = new PurchaseOrderDetailFilter();
		//this.getParts();
		//this.getPurchaseOrders();
		//this.getPurchaseRequests();
		//this.getVendors();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPurchaseOrder(id);
			} else {
				this.modelId = id;
				this.getPurchaseOrder(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				return true;
			}
		}
	},
	watch: {
		sortByPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		sortDescPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		currentPurchaseOrderDetailPage: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		purchaseOrderDetailPageSize: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		filterPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			},
			deep: true,
		},
	},
}
</script>
